/** @graphql cc **/

import gql from 'graphql-tag';

export const HomeDraftsQuery = gql`
	query HomeDraftsQuery($cqlcontext: String, $first: Int, $after: String) {
		search(
			cql: "type in (page,blogpost) order by lastModified desc"
			cqlcontext: $cqlcontext
			first: $first
			after: $after
		) {
			nodes {
				content {
					id
					title
					type
					subType
					links {
						webui
						editui
					}
					excerpt(length: 372)
					metadata {
						currentuser {
							favourited {
								isFavourite
							}
						}
						comments {
							commentsCount
						}
					}
					space {
						alias
						id
						key
						name
					}
					likes {
						count
					}
					status
					blank
					metadata {
						lastModifiedDate
					}
					editorVersion: properties(key: "editor") {
						nodes {
							id
							key
							value
						}
					}
					emoji: properties(keys: ["emoji-title-draft"]) {
						nodes {
							id
							key
							value
						}
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;
